<template>
  <div
    id="fence-draw"
    class="w-100 h-100 position-absolute p-10"
    :style="{ height: height, top: top }"
  >
    <el-card class="w-100 top-card" :body-style="{ height: 'calc(100% - 30px)', padding: '0px' }">
      <el-row :gutter="10" class="fz-14 c-white">
        <el-col :span="12">
          <span>电子围栏列表</span>
        </el-col>
        <el-col :span="12">
          <span class="iconfont icon-close r cur_pointer" @click="closeComponent"></span>
        </el-col>
      </el-row>
      <el-table
        :data="dataList"
        ref="fenceTable"
        border
        v-loading="fenceListLoading"
        highlight-current-row
        class="w-100 data-table m-t-10"
        height="calc(100% - 45px)"
        @cell-click="chooseFence"
      >
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="name" label="围栏名称" align="center"></el-table-column>
        <el-table-column prop="regname" label="电子围栏区域" align="center"></el-table-column>
      </el-table>
      <div class="m-t-10 r">
        <el-pagination
          background
          popper-class="document_select-popper"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes,prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </el-card>
    <el-card
      class="w-100 position-relative bottom-card"
      :body-style="{
        width: '100%',
        height: 'calc(100% - 85px)',
        padding: '0px',
      }"
    >
      <span class="c-white fz-14">{{ fenceId ? '编辑围栏' : '新增围栏' }}</span>
      <div class="edit-form w-100 h-100 p-10 m-t-10">
        <el-form
          :model="fenceForm"
          ref="fenceForm"
          label-width="72px"
          class="m-t-20"
          :rules="fenceRules"
          size="mini"
        >
          <el-form-item label="围栏名称" prop="name">
            <el-input clearable class="w-100" v-model="fenceForm.name" placeholder></el-input>
          </el-form-item>
          <el-form-item label="开始时间" prop="begin_TIME">
            <el-time-picker
              clearable
              class="date-picker"
              popper-class="document_select-popper"
              v-model="fenceForm.begin_TIME"
              placeholder="开始时间"
              value-format="HH:mm:ss"
            ></el-time-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="end_TIME">
            <el-time-picker
              clearable
              class="date-picker"
              popper-class="document_select-popper"
              v-model="fenceForm.end_TIME"
              placeholder="结束时间"
              value-format="HH:mm:ss"
            ></el-time-picker>
          </el-form-item>
          <el-form-item label="围栏开关" prop="bypass">
            <el-select
              clearable
              class="w-100"
              filterable
              popper-class="document_select-popper"
              v-model="fenceForm.bypass"
              placeholder="请选择"
            >
              <el-option
                v-for="item in switchList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="围栏类型" prop="fencetype">
            <el-input class="w-100" v-model="fenceForm.fencetype" readonly placeholder></el-input>
          </el-form-item>
          <el-form-item label="延迟时间">
            <el-input clearable class="w-100" v-model="fenceForm.delaytime" placeholder>
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
          <el-form-item label="关联标签ID">
            <el-select
              clearable
              class="w-100"
              filterable
              popper-class="document_select-popper"
              v-model="fenceForm.related_TAGID"
              multiple
              collapse-tags
              placeholder="请选择"
            >
              <el-option
                v-for="item in relationTagIdList"
                :key="item.id"
                :label="item.username"
                :value="item.tagid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图层信息" prop="regid">
            <el-select
              clearable
              class="w-100"
              filterable
              popper-class="document_select-popper"
              v-model="fenceForm.regid"
              placeholder="请选择"
            >
              <el-option
                v-for="item in fenceAreaList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label="围栏坐标" prop="position">
                <el-row
                  type="flex"
                  align="middle"
                  class="m-b-5"
                  v-for="(item, index) in fenceForm.position"
                  :key="index + 's'"
                >
                  <el-col :span="5" class="m-r-5">
                    <el-input
                      class="w-100"
                      v-model="item.X"
                      placeholder
                      @keyup.enter.native="changePillarPosition"
                      @input="inputUpdate"
                    ></el-input>
                  </el-col>
                  <el-col :span="5" class="m-r-5">
                    <el-input
                      class="w-100"
                      v-model="item.Y"
                      placeholder
                      @keyup.enter.native="changePillarPosition"
                      @input="inputUpdate"
                    ></el-input>
                  </el-col>
                  <el-col :span="5" class="m-r-5">
                    <el-input
                      class="w-100"
                      v-model="item.Z"
                      placeholder
                      @keyup.enter.native="changePillarPosition"
                      @input="inputUpdate"
                    ></el-input>
                  </el-col>
                  <el-col :span="7">
                    <el-tooltip
                      placement="top"
                      content="新增"
                      :open-delay="1000"
                      v-if="index === fenceForm.position.length - 1"
                    >
                      <el-button
                        type="primary"
                        size="mini"
                        class="m-l-0 m-r-5"
                        icon="iconfont icon-add"
                        @click="addPositionVertex"
                        v-buttonMonitor="{ name: '新增', operate: 'create' }"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      placement="top"
                      content="删除"
                      v-if="fenceForm.position.length > 1"
                      :open-delay="1000"
                    >
                      <el-button
                        type="danger"
                        size="mini"
                        class="m-l-0"
                        @click="removePositionVertex(index)"
                        icon="iconfont icon-close"
                        v-buttonMonitor="{ name: '删除', operate: 'delete' }"
                      ></el-button>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="card-footer position-absolute">
        <el-button :loading="saveFenceLoading" type="primary" @click="addNewFence" size="mini"
          >新 增</el-button
        >
        <el-button :loading="saveFenceLoading" @click="cancleEditFence" size="mini"
          >重 置</el-button
        >
        <el-button :loading="saveFenceLoading" type="primary" @click="submitFence" size="mini"
          >保 存</el-button
        >
        <el-button :loading="saveFenceLoading" type="primary" size="mini" @click="activateTool"
          >激活工具</el-button
        >
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiMixinDocument from '@/assets/js/api/documents'
import LocalSense from '@/services/baoChang/localSense'

export default {
  name: 'FenceDraw',
  components: {},
  mixins: [ApiMixinDocument],
  props: {
    height: {
      type: String,
      defalut: '',
    },
    top: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    documentId: {
      type: String,
      defalut: '',
    },
  },
  data() {
    const checkNumber = (rule, value, calback) => {
      const numberReg = /^(-)?(\d+)(\.\d+)?$/
      const checkValue = _.every(value, (item) => {
        return numberReg.test(item.X) && numberReg.test(item.Y) && numberReg.test(item.Z)
      })
      if (!checkValue) {
        calback(new Error('请输入正确的围栏坐标'))
      } else {
        calback()
      }
    }
    return {
      fenceForm: {
        // 编辑表单信息
        name: '',
        begin_TIME: '',
        end_TIME: '',
        regid: '',
        fencetype: 0,
        delaytime: '',
        bypass: '',
        position: [
          {
            X: 0,
            Y: 0,
            Z: 0,
          },
        ],
        related_TAGID: [],
      },
      fenceRules: {
        name: [{ required: true, message: '请填写围栏名称', trigger: 'blur' }],
        begin_TIME: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        end_TIME: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        fencetype: [{ required: true, message: '请填写围栏类型', trigger: 'blur' }],
        regid: [{ required: true, message: '请选择图层信息', trigger: 'change' }],
        position: [{ validator: checkNumber, trigger: 'blur' }],
      },
      fenceList: [], // 电子围栏列表
      fenceAreaList: [], // 电子围栏图层信息
      fenceListLoading: false, // 电子围栏加载
      relationTagIdList: [], // 权限内目标
      switchList: [
        { value: 0, label: '打开' },
        { value: 1, label: '关闭' },
      ], // 围栏开关列表
      saveFenceLoading: false,
      fenceId: '', // 围栏id
      fenceModelObject: null, // 电子围栏对象指针
      isActivateTool: false, // 是否激活状态下
      createPillarPos: [], // 通过鼠标创建围栏时存放数据
      timerOut: null, // 防抖
      clickTableTimerOut: null, // 点击列表防抖
      pageTotal: 0,
      pageNo: 1,
      pageSize: 15,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 前端分页处理
    dataList() {
      return this.fenceList.slice((this.pageNo - 1) * this.pageSize, this.pageNo * this.pageSize)
    },
  },
  watch: {},
  async created() {
    await this.getFenceList()
    this.fenceId = this.fenceList[0].id
    this.getFenceDetail(this.fenceList[0])
    this.getRelationTags()
    this.getFenceAreaList()
  },
  beforeDestroy() {
    if (this.fenceModelObject) {
      this.isActivateTool = false
      this.createPillarPos = []
      this.player.Native.ElectoronicRail.setEditMode(false)
      this.player.Native.ElectoronicRail.destroy(this.fenceModelObject)
      this.player.Native.Camera.EventAnchorPosChanged.disconnect(this.watchAnchorPos)
    }
  },
  methods: {
    // 关闭组件
    closeComponent() {
      this.$emit('closeComponent', 'FenceDraw')
    },
    // 修改围栏坐标
    changePillarPosition() {
      if (this.timerOut) clearTimeout(this.timerOut)
      this.timerOut = setTimeout(async () => {
        if (this.fenceId) {
          this.drawFence()
        } else {
          if (this.fenceModelObject) {
            this.player.Native.ElectoronicRail.destroy(this.fenceModelObject)
          }
          // 允许编辑
          this.player.Native.ElectoronicRail.setEditMode(true)
          // 初始化
          this.fenceModelObject = await this.player.Native.ElectoronicRail.create('newFence', 2.0)
          _.forEach(this.fenceForm.position, (item) => {
            this.player.Native.ElectoronicRail.addFencePillar(this.fenceModelObject, [
              item.X,
              item.Y,
              item.Z,
            ])
          })
          if (!this.isActivateTool) {
            this.player.Native.ElectoronicRail.setEditMode(false)
          }
        }
      }, 500)
    },
    // 监听锚点位置
    async watchAnchorPos(pos) {
      this.createPillarPos.push({ X: pos[0], Y: pos[1], Z: pos[2] })
      const pillarCount = await this.player.Native.ElectoronicRail.fencePillarCount(
        this.fenceModelObject
      )
      if (this.createPillarPos.length > pillarCount) {
        this.player.Native.Camera.EventAnchorPosChanged.disconnect(this.watchAnchorPos)
        return
      }
      this.fenceForm.position = _.cloneDeep(this.createPillarPos)
      this.$forceUpdate()
    },
    // 取消编辑围栏
    async cancleEditFence() {
      this.player.Native.Camera.EventAnchorPosChanged.disconnect(this.watchAnchorPos)
      this.isActivateTool = false
      this.createPillarPos = []
      this.player.Native.ElectoronicRail.setEditMode(false)
      if (this.fenceId) {
        const res = await LocalSense.getFenceDetail({
          ID: this.fenceId,
        })
        if (res && res.code === 0 && res.data && res.data.rows && res.data.vertex) {
          this.fenceForm = res.data.rows
          this.fenceForm.related_TAGID = res.data.rows.related_TAGID
            ? res.data.rows.related_TAGID.split(':')
            : ''
          this.fenceForm.position = _.map(_.sortBy(res.data.vertex, 'VERTEX_ID'), (item) => {
            return _.pick(item, ['X', 'Y', 'Z'])
          })
        }
        if (this.fenceModelObject) {
          this.player.Native.ElectoronicRail.destroy(this.fenceModelObject)
        }
        this.drawFence()
      } else {
        this.addNewFence()
      }
    },
    // 激活操作云渲染
    async activateTool() {
      if (!this.isActivateTool) {
        this.createPillarPos = []
        this.isActivateTool = true
        this.player.Native.ElectoronicRail.setEditMode(true)
        this.player.Native.ElectoronicRail.setEditType(2)
        if (_.isNil(this.fenceId) || this.fenceForm.position.length <= 1) {
          // 初始化
          this.fenceModelObject = await this.player.Native.ElectoronicRail.createByMouse(
            'newFence',
            1,
            2.0
          )
          this.player.Native.ElectoronicRail.setSelect(this.fenceModelObject, true)
          this.player.Native.Camera.EventAnchorPosChanged.connect(this.watchAnchorPos)
        }
      }
    },
    // 获取电子围栏列表
    async getFenceList() {
      this.fenceListLoading = true
      const res = await LocalSense.getAllList(0)
      this.fenceListLoading = false
      if (res && res.code === 0 && res.data && res.data.rows) {
        this.fenceList = res.data.rows
        this.pageTotal = this.fenceList.length
      }
    },
    // 获取电子围栏图层信息
    async getFenceAreaList() {
      const res = await LocalSense.getFenceAreaInfo({
        type: 9,
        /** 0：查询全部 1：基站编组
            2：电子围栏 3：考勤区域
            4：巡检区域 5：电子点名
            6：基站信息 7：视频联动
            8：场景信息 9：地图信息 */
      })
      if (res && res.code === 0 && res.data && res.data.rows) {
        this.fenceAreaList = res.data.rows['地图信息']
      }
    },
    // 查询权限内目标集合
    async getRelationTags() {
      const res = await LocalSense.getRelationTags()
      console.log(res)
      if (res && res.code === 0 && res.data && res.data.rows) {
        this.relationTagIdList = res.data.rows
      }
    },
    // 强制刷新输入框
    inputUpdate() {
      this.$forceUpdate()
    },
    // 新增围栏坐标
    addPositionVertex() {
      this.fenceForm.position.push({
        X: 0,
        Y: 0,
        Z: 0,
      })
      this.$forceUpdate()
    },
    // 移除围栏坐标
    async removePositionVertex(index) {
      this.fenceForm.position.splice(index, 1)
      this.$forceUpdate()
      if (this.fenceForm.position.length <= 1) {
        this.createPillarPos = []
        if (this.fenceModelObject) {
          this.player.Native.ElectoronicRail.destroy(this.fenceModelObject)
        }
        // 初始化
        this.fenceModelObject = await this.player.Native.ElectoronicRail.createByMouse(
          'newFence',
          1,
          2.0
        )
        if (this.isActivateTool) {
          this.player.Native.Camera.EventAnchorPosChanged.disconnect(this.watchAnchorPos)
          this.player.Native.ElectoronicRail.setSelect(this.fenceModelObject, true)
          this.player.Native.Camera.EventAnchorPosChanged.connect(this.watchAnchorPos)
        }
        return
      }
      if (this.player && this.player.Native) {
        this.drawFence()
      }
    },
    // 画电子围栏
    async drawFence() {
      if (this.fenceForm) {
        if (this.fenceModelObject) {
          this.player.Native.ElectoronicRail.destroy(this.fenceModelObject)
        }
        // 允许编辑
        this.player.Native.ElectoronicRail.setEditMode(true)
        // 初始化
        this.fenceModelObject = await this.player.Native.ElectoronicRail.create(
          this.fenceForm.id,
          2.0
        )
        _.forEach(this.fenceForm.position, (item) => {
          this.player.Native.ElectoronicRail.addFencePillar(this.fenceModelObject, [
            item.X,
            item.Y,
            item.Z,
          ])
        })
        if (!this.isActivateTool) {
          this.player.Native.ElectoronicRail.setEditMode(false)
        }
      }
    },
    // 新增电子围栏
    addNewFence() {
      this.isActivateTool = false
      this.fenceId = null
      this.$refs.fenceForm.resetFields()
      this.fenceForm = this.$options.data().fenceForm
      if (this.fenceModelObject) {
        this.player.Native.Camera.EventAnchorPosChanged.disconnect(this.watchAnchorPos)
        this.player.Native.ElectoronicRail.destroy(this.fenceModelObject)
      }
    },
    // 点击列表画电子围栏
    chooseFence(row) {
      if (this.player && this.player.Native) {
        this.player.Native.Camera.EventAnchorPosChanged.disconnect(this.watchAnchorPos)
      }
      this.$refs.fenceForm.resetFields()
      this.isActivateTool = false
      if (this.clickTableTimerOut) clearTimeout(this.clickTableTimerOut)
      this.clickTableTimerOut = setTimeout(async () => {
        await this.getFenceDetail(row)
        await this.drawFence()
        if (this.player && this.player.Native) {
          // 获取模型所在的坐标系
          const mat = await PlayerUtils.call(
            this.player.Native.Model.getModelGlobalMatrix,
            this.documentId
          )
          setTimeout(async () => {
            if (this.fenceModelObject) {
              const aabbRes = await this.player.Native.ElectoronicRail.getAabb(
                this.fenceModelObject
              )
              const aabb = {
                min: aabbRes[0],
                max: aabbRes[1],
              }
              this.player.Native.Camera.moveToAabb(aabb, mat, 1, 0.5, 1)
            }
          }, 500)
        }
      }, 500)
    },
    // 获取围栏详情
    async getFenceDetail(row) {
      if (row) {
        this.fenceId = row.id
        const res = await LocalSense.getFenceDetail({
          ID: row.id,
        })
        if (res && res.code === 0 && res.data && res.data.rows && res.data.vertex) {
          this.fenceForm = res.data.rows
          this.fenceForm.related_TAGID = res.data.rows.related_TAGID
            ? res.data.rows.related_TAGID.split(':')
            : ''
          this.fenceForm.position = _.map(_.sortBy(res.data.vertex, 'VERTEX_ID'), (item) => {
            return _.pick(item, ['X', 'Y', 'Z'])
          })
        }
      }
    },
    // 保存围栏
    submitFence() {
      this.$refs.fenceForm.validate(async (value) => {
        if (value) {
          const fenceVertex = _.map(this.fenceForm.position, (item, index) => {
            return { VERTEX_ID: index, ...item }
          })
          const regName = _.find(this.fenceAreaList, ['id', this.fenceForm.regid])
          const params = {
            Name: this.fenceForm.name,
            BeginTime: this.fenceForm.begin_TIME,
            EndTime: this.fenceForm.end_TIME,
            DelayTime: this.fenceForm.delaytime,
            RegId: this.fenceForm.regid,
            RegName: regName ? regName.name : '',
            ByPass: this.fenceForm.bypass,
            Vertex: JSON.stringify(fenceVertex),
            FenceType: 0,
          }
          if (this.isActivateTool && this.fenceModelObject) {
            const pillarCount = await this.player.Native.ElectoronicRail.fencePillarCount(
              this.fenceModelObject
            )
            const pillarVertex = []
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < pillarCount; i++) {
              // eslint-disable-next-line no-await-in-loop
              const wallInfo = await this.player.Native.ElectoronicRail.wallData(
                this.fenceModelObject,
                i
              )
              pillarVertex.push({
                VERTEX_ID: i,
                X: wallInfo.prevBottomPt[0],
                Y: wallInfo.prevBottomPt[1],
                Z: wallInfo.prevBottomPt[2],
              })
            }
            params.Vertex = JSON.stringify(pillarVertex)
            this.fenceForm.position = _.map(_.sortBy(pillarVertex, 'VERTEX_ID'), (item) => {
              return _.pick(item, ['X', 'Y', 'Z'])
            })
          }
          this.saveFenceLoading = true
          let res = null
          if (this.fenceId) {
            params.Id = this.fenceId
            params.EditedMan = this.fenceForm.related_TAGID.join(';')
            res = await LocalSense.editFence(params)
          } else {
            params.ReletedMan = this.fenceForm.related_TAGID.join(';')
            res = await LocalSense.addFence(params)
          }
          this.isActivateTool = false
          this.player.Native.Camera.EventAnchorPosChanged.disconnect(this.watchAnchorPos)
          this.createPillarPos = []
          this.saveFenceLoading = false
          if (res && res.code === 0) {
            this.$message.success('操作成功！')
            await this.getFenceList()
            if (!this.fenceId) {
              this.fenceId = _.last(this.fenceList).id
              this.fenceForm.id = this.fenceId
            }
            this.drawFence()
          } else {
            this.$message.warning(res.message)
          }
          return true
        }
        return false
      })
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/select.scss';
@import '../../css/index.scss';

#fence-draw {
  width: 368px;
  right: 35px;
  z-index: 999;
  background-color: rgba(46, 107, 176, 0.5) !important;
}
.edit-form {
  overflow-y: auto;
  background-color: rgba(24, 41, 72, 0.5) !important;
}
.top-card {
  height: calc(50% - 10px);
}
.bottom-card {
  height: 50%;
}
/deep/ .el-card__body {
  height: 100%;
  tr.current-row > td {
    background-color: #e8e882;
  }
  tr.el-table__row--striped.current-row td {
    background-color: #e8e882 !important;
  }
}
.card-footer {
  bottom: 10px;
  right: 10px;
  border: none;
}
/deep/ .el-table--border th,
.el-table--border td {
  border: none !important;
}
.date-picker {
  width: 100% !important;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: #409eff90 !important;
  border: none;
  color: #fff;
}

</style>
